<template>
  <div>
    <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isSyaratBayarActive" position-right>
      <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
          <h5 class="text-white">Tambah Syarat Bayar</h5>
          <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="syaratbayarAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
        </div>

        <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.rtl">
          <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input label="Syarat Bayar" v-model="dataSyaratBayar" class="mt-5 w-full" name="item-syaratbayar" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('item-syaratbayar')">{{ errors.first('item-syaratbayar') }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-textarea v-model="dataKeterangan" label="Keterangan" class="mt-1 w-full"/>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <vs-button type="border" color="danger" @click="syaratbayarAddClose">Cancel</vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-end">
                <vs-button :disabled="!isFormValid" @click="submitData" color="primary">Submit</vs-button>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default{
  props: {
    isSyaratBayarActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },

      dataId: null,
      dataSyaratBayar: null,
      dataGroup: 0,
      dataParent: 0,
      dataKeterangan: null
    }
  },
  watch: {
    isSyaratBayarActive (value) {
      if (!value) { return } 
    }
  },
  computed: {
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag
    },
    windowWidth ()  { 
      return this.$store.state.windowWidth                 
    },
    isFormValid () {
      return !this.errors.any() && this.dataSyaratBayar && this.dataKeterangan
    },
    ...mapGetters({
      user : 'auth/user',
    })
  },
  methods: {
    initValues() {
      //if (this.syaratbayarData.id) return
      this.dataId = null
      this.dataSyaratBayar = null
      this.dataGroup = 0
      this.dataParent = 0
      this.dataKeterangan = null
    },
    syaratbayarAddClose() {
      this.$emit('closeSyaratBayar')
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataSyaratBayar,
            term_group: this.dataGroup,
            parent: this.dataParent,

            meta : {
              keterangan: this.dataKeterangan
            },
            taxonomy: 'syaratbayar'
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('syaratbayar/updateSyaratBayar', obj)
          } else {
            delete obj.id
            this.$store.dispatch('syaratbayar/addSyaratBayar', obj)
          }
          this.$emit('closeSyaratBayar')
          this.initValues()
        }
      })
    }
  }
}

</script>